import { action } from 'satcheljs';
import type { SearchScenarioId } from 'owa-search-store';

export interface ON_ENTER_PRESSED_SEARCH_INPUTActionMessage {
    selectedSuggestionIndex: number;
    scenarioId: SearchScenarioId;
}
export const onEnterPressedSearchInput: (
    selectedSuggestionIndex: number,
    scenarioId: SearchScenarioId
) => ON_ENTER_PRESSED_SEARCH_INPUTActionMessage = action(
    'ON_ENTER_PRESSED_SEARCH_INPUT',
    (
        selectedSuggestionIndex: number,
        scenarioId: SearchScenarioId
    ): ON_ENTER_PRESSED_SEARCH_INPUTActionMessage => ({
        selectedSuggestionIndex,
        scenarioId,
    })
);
